import { type IntlShape } from "react-intl";
import { type ColDef } from "ag-grid-community";
import { TranslateRequiredTableColumns } from "@ui-components/AgGridTable/constants/translateKeys";
import { RequiredTableCols } from "@ui-components/AgGridTable/constants/tableCols";
import type { Contacts } from "@binale-tech/shared";

export class AbstractTableColumns {
    protected constructor() {}

    static intl: IntlShape;
    static contacts: Map<string, Contacts.Contact>;

    static set setIntl(v: IntlShape) {
        this.intl = v;
    }

    static rowNumberColumn<TData = unknown>(): Readonly<ColDef<TData>> {
        return {
            headerName: this.intl?.formatMessage({ id: TranslateRequiredTableColumns[RequiredTableCols.ROW_NUMBER] }),
            colId: RequiredTableCols.ROW_NUMBER,
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 60,
            minWidth: 60,
            maxWidth: 120,
            resizable: true,
            filter: false,
            suppressHeaderMenuButton: true,
            suppressMovable: true,
            lockPosition: true,
            suppressNavigable: true,
        };
    }

    static actions<TData = unknown>(): Readonly<ColDef<TData>> {
        return {
            colId: RequiredTableCols.ACTIONS,
            floatingFilter: false,
            filter: false,
            resizable: false,
            suppressMovable: true,
            suppressNavigable: true,
            width: 180,
            pinned: "right",
            sortable: false,
            lockPosition: true,
            cellClass: [],
        };
    }
}
